import { isEVMChain, isSolanaChain } from '@particle-network/connector-core';
import { connect, type ConnectParameters, type ConnectReturnType } from '../actions/connect';
import { useContext } from '../context';
import { useLastConnectorId } from './useLastConnectorId';
import { useMutation, type MutationOptions } from './useMutation';

type UseConnectParameters = MutationOptions<ConnectReturnType, ConnectParameters>;

export default function useConnect(parameters?: UseConnectParameters) {
  const { config, options } = useContext();
  const { updateLastConnectorId } = useLastConnectorId();

  const mutationFn = async (parameters: ConnectParameters) => {
    const { connector, chainId } = parameters;
    let connectChainId = chainId;
    if (!connectChainId) {
      if (connector.chainType === 'evm') {
        connectChainId = options.initialChainId?.evm;
        if (!connectChainId) {
          connectChainId = config.chains.find(isEVMChain)?.id;
        }
      } else {
        connectChainId = options.initialChainId?.solana;
        if (!connectChainId) {
          connectChainId = config.chains.find(isSolanaChain)?.id;
        }
      }
    }
    const result = await connect(config, {
      ...parameters,
      chainId: connectChainId,
    });
    if (connector.id !== 'walletConnect') {
      updateLastConnectorId(connector.id);
    }

    return result;
  };

  const { status, data, error, mutate, mutateAsync } = useMutation(mutationFn, parameters);

  return {
    status,
    data,
    error,
    connect: mutate,
    connectAsync: mutateAsync,
  };
}
